<template>
	<card class="tw-text-center">
		<div class="tw-py-2">
			<stepper :steps="VALUATION_MODEL_STEPS" :current-step="currentStep" />
		</div>
	</card>
</template>

<script>
import Card from '@/modules/shared/components/ui/Card/Card';
import Stepper from '@/modules/shared/components/ui/stepper/Stepper';
import { VALUATION_MODEL_STEPS } from '../../../../constants/constants';

export default {
	name: 'ValuationModelStepper',
	components: { Stepper, Card },
	props: ['currentStep'],
	data() {
		return {
			VALUATION_MODEL_STEPS,
		};
	},
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/modules/job-evaluation/components/supplies/valuation-model/valuation-model/ValuationModelStepper.vue